import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
    authHeader: localStorage.getItem('authHeader') || '',

    dailyUsage: parseInt(localStorage.getItem('dailyUsage') || 0),
    dailyLimit: parseInt(localStorage.getItem('dailyLimit') || 3),
  },

  getters: {
    getToken: state => state.token,
    getUserInfo: state => state.userInfo,
    getAuthHeader: state => state.authHeader,
    getDailyUsage: state => state.dailyUsage,
    getDailyLimit: state => state.dailyLimit,
  },

  mutations: {
    SET_USER_INFO(state, data) {
      state.token = data.token
      state.userInfo = data
      state.authHeader = `${data.tokenType} ${data.token}`

      localStorage.setItem('token', data.token)
      localStorage.setItem('userInfo', JSON.stringify(data))
      localStorage.setItem('authHeader', state.authHeader)
    },

    UPDATE_VIP_LEVEL(state, vipLevel) {
      state.userInfo.vipLevel = vipLevel
      localStorage.setItem('userInfo', JSON.stringify(state.userInfo))
    },

    // 固定
    SET_DAILY_INFO(state, { usage, limit }) {
      state.dailyUsage = usage
      state.dailyLimit = limit
      localStorage.setItem('dailyUsage', usage)
      localStorage.setItem('dailyLimit', limit)
    },

    CLEAR_USER_INFO(state) {
      state.token = ''
      state.userInfo = {}
      state.authHeader = ''
      state.dailyUsage = 0
      state.dailyLimit = 3
      localStorage.clear()
    }
  },

  actions: {
    saveUserInfo({ commit }, data) {
      commit('SET_USER_INFO', data)
    },

    updateVipLevel({ commit }, vipLevel) {
      commit('UPDATE_VIP_LEVEL', vipLevel)
    },

    // 固定：setDailyInfo
    setDailyInfo({ commit }, data) {
      commit('SET_DAILY_INFO', data)
    }
  },

  modules: {}
})

export default store